import { render, staticRenderFns } from "./B.vue?vue&type=template&id=7526bda9&scoped=true&"
import script from "./B.vue?vue&type=script&lang=js&"
export * from "./B.vue?vue&type=script&lang=js&"
import style0 from "./B.vue?vue&type=style&index=0&id=7526bda9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7526bda9",
  null
  
)

export default component.exports